import React from "react";
import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import ViewImages from "../viewImages/viewImages";
import { formatOrNA } from "../../../../utils/helper";

const PoliceReporting = ({ policeReporting }) => {
  const imageSize = {
    size: "small",
  };

  const image = [];
  const totalImg = policeReporting?.picturesOfRoadway?.map((i) =>
    image.push(i.value)
  );
  return (
    <div className="commonOveride">
      <Box className="commoninfoWrap">
        <Box className="commoninfoBox">
          <Box className="commoninfoleft">
            <Typography className="title">Police Reporting:</Typography>

            <Box className="columns">
              <Typography className="listView">
                Responding Law Enforcement Agency:
                <span className="font-w400">
                  {formatOrNA(policeReporting?.police_department)}
                </span>
              </Typography>
              <Typography className="listView">
                Report Case Number:
                <span className="font-w400">
                  {formatOrNA(policeReporting?.police_case_number)}
                </span>
              </Typography>
            </Box>
            <Typography className="listView">
              Number of Injuries Reported:
              <span className="font-w400">
                {formatOrNA(policeReporting?.total_injuries)}
              </span>
            </Typography>

            <Typography className="listView desNone">
              Files:
              {image?.length > 0 ? (
                <ViewImages
                  image={image}
                  imageSize={imageSize}
                  showName={false}
                />
              ) : (
                <span className="font-w400">N/A</span>
              )}
            </Typography>
          </Box>
          <Box className="commoninfoRight"></Box>
        </Box>
      </Box>
    </div>
  );
};

export default PoliceReporting;
